// Get All HDFC Retail Records Constants
export const GET_ALL_HDFC_RETAIL_REQUEST = 'GET_ALL_HDFC_RETAIL_REQUEST'
export const GET_ALL_HDFC_RETAIL_SUCCESS = 'GET_ALL_HDFC_RETAIL_SUCCESS'
export const GET_ALL_HDFC_RETAIL_FAIL = 'GET_ALL_HDFC_RETAIL_FAIL'
export const GET_ALL_HDFC_RETAIL_RESET = 'GET_ALL_HDFC_RETAIL_RESET'

// Import HDFC Retail Records Constants
export const IMPORT_HDFC_RETAIL_REQUEST = 'IMPORT_HDFC_RETAIL_REQUEST'
export const IMPORT_HDFC_RETAIL_SUCCESS = 'IMPORT_HDFC_RETAIL_SUCCESS'
export const IMPORT_HDFC_RETAIL_FAIL = 'IMPORT_HDFC_RETAIL_FAIL'
export const IMPORT_HDFC_RETAIL_RESET = 'IMPORT_HDFC_RETAIL_RESET'

// Export HDFC Retail Records Constants
export const EXPORT_HDFC_RETAIL_REQUEST = 'EXPORT_HDFC_RETAIL_REQUEST'
export const EXPORT_HDFC_RETAIL_SUCCESS = 'EXPORT_HDFC_RETAIL_SUCCESS'
export const EXPORT_HDFC_RETAIL_FAIL = 'EXPORT_HDFC_RETAIL_FAIL'
export const EXPORT_HDFC_RETAIL_RESET = 'EXPORT_HDFC_RETAIL_RESET'

// Update HDFC Retail Record Constants
export const UPDATE_HDFC_RETAIL_REQUEST = 'UPDATE_HDFC_RETAIL_REQUEST'
export const UPDATE_HDFC_RETAIL_SUCCESS = 'UPDATE_HDFC_RETAIL_SUCCESS'
export const UPDATE_HDFC_RETAIL_FAIL = 'UPDATE_HDFC_RETAIL_FAIL'
export const UPDATE_HDFC_RETAIL_RESET = 'UPDATE_HDFC_RETAIL_RESET'

// Delete HDFC Retail Record Constants
export const DELETE_HDFC_RETAIL_REQUEST = 'DELETE_HDFC_RETAIL_REQUEST'
export const DELETE_HDFC_RETAIL_SUCCESS = 'DELETE_HDFC_RETAIL_SUCCESS'
export const DELETE_HDFC_RETAIL_FAIL = 'DELETE_HDFC_RETAIL_FAIL'
export const DELETE_HDFC_RETAIL_RESET = 'DELETE_HDFC_RETAIL_RESET'

// Update HDFC Retail Cell (Inline Editing) Constants
export const UPDATE_HDFC_RETAIL_CELL_REQUEST = 'UPDATE_HDFC_RETAIL_CELL_REQUEST'
export const UPDATE_HDFC_RETAIL_CELL_SUCCESS = 'UPDATE_HDFC_RETAIL_CELL_SUCCESS'
export const UPDATE_HDFC_RETAIL_CELL_FAIL = 'UPDATE_HDFC_RETAIL_CELL_FAIL'
export const UPDATE_HDFC_RETAIL_CELL_RESET = 'UPDATE_HDFC_RETAIL_CELL_RESET'

export const BULK_DELETE_HDFC_RETAIL_REQUEST = 'BULK_DELETE_HDFC_RETAIL_REQUEST'
export const BULK_DELETE_HDFC_RETAIL_SUCCESS = 'BULK_DELETE_HDFC_RETAIL_SUCCESS'
export const BULK_DELETE_HDFC_RETAIL_FAIL = 'BULK_DELETE_HDFC_RETAIL_FAIL'
export const BULK_DELETE_HDFC_RETAIL_RESET = 'BULK_DELETE_HDFC_RETAIL_RESET'

export const CREATE_HDFC_RETAIL_REQUEST = 'CREATE_HDFC_RETAIL_REQUEST'
export const CREATE_HDFC_RETAIL_SUCCESS = 'CREATE_HDFC_RETAIL_SUCCESS'
export const CREATE_HDFC_RETAIL_FAIL = 'CREATE_HDFC_RETAIL_FAIL'
export const CREATE_HDFC_RETAIL_RESET = 'CREATE_HDFC_RETAIL_RESET'

// Add these constants at the end of the file
export const SYNC_HDFC_RETAIL_TASK_STATUS_REQUEST = 'SYNC_HDFC_RETAIL_TASK_STATUS_REQUEST';
export const SYNC_HDFC_RETAIL_TASK_STATUS_SUCCESS = 'SYNC_HDFC_RETAIL_TASK_STATUS_SUCCESS';
export const SYNC_HDFC_RETAIL_TASK_STATUS_FAIL = 'SYNC_HDFC_RETAIL_TASK_STATUS_FAIL';
export const SYNC_HDFC_RETAIL_TASK_STATUS_RESET = 'SYNC_HDFC_RETAIL_TASK_STATUS_RESET';